import React from 'react';
import Localized from '../../../localization';
import ErrorCodesMap from './error-codes.map';
import {
  SubmitTravelDetails,
  GetEligibilityDetails,
} from '../../utilities/requestutils';
import {
  getLocale,
  getKeyForLocale,
} from '../../mappers/brands/brand-information.mapper';
import getMappedObject from '../../mappers/request-mappers/bulk-cancel-request.mapper';

const LODGING = 'LODGING';
const OTHERS = 'OTHERS';

class TravelAlertRefund extends React.Component {
  constructor(props) {
    super(props);
    this.enablePnr = false;
    this.state = {
      product: 'package',
      initiator: 'customer',
      emailAddress: '',
      emailAddressErrorIsVisible: false,
      phoneNumber: '',
      phoneNumberErrorIsVisible: false,
      itinerary: '',
      itineraryErrorIsVisible: false,
      formSubmitted: false,
      isEligible: false,
      isError: false,
    };
    this.disableFormSubmission = false;
    this.bulkCancelRequestSubmitHandler =
      this.bulkCancelRequestSubmitHandler.bind(this);
    this.eligibilityRequestSubmitHandler =
      this.eligibilityRequestSubmitHandler.bind(this);
    this.validationHandler = this.validationHandler.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.showSubmissionForm = this.showSubmissionForm.bind(this);
    const { brand, metaInfo, host } = this.parseBrandInformation();
    this.brandName = brand;
    this.locale = getLocale(brand, metaInfo, host);
    Localized.setLanguage(getKeyForLocale(this.locale));
  }

  componentDidMount() {
    const {
      channel_origin_id: channelOriginId,
      itin,
      email,
      phone,
      pointOfSale,
      campaign_id: campaignId,
    } = this.parseQueryParams();
    const { brand, tpid, eapid } = this.parseBrandInformation();
    const { state } = this.state;
    this.setState({
      ...state,
      channelOriginId,
      brand,
      locale: this.locale,
      itinerary: itin,
      emailAddress: email,
      phoneNumber: phone,
      tpid,
      eapid,
      pointOfSale,
      campaignId,
    });
  }

  // Response consists of a header & body. Header shown in UI with bold & red text.
  getLocalizedErrorMessageObject(errorCode) {
    const localizedKey = ErrorCodesMap[errorCode];
    if (typeof localizedKey === 'object') {
      let errorMessageBody = '';
      // When error body consists of multiple messages append it here.
      localizedKey.body.forEach((key) => {
        errorMessageBody += `${Localized[key]}`;
      });
      return {
        header: Localized[localizedKey.header],
        body: errorMessageBody,
      };
    }
    return {
      header: Localized[localizedKey] || Localized.Failed,
    };
  }

  getLocalizedEligibility(response, hasLodging) {
    const placeholder = '{x}';
    const mappedLocalizedObject = Object.entries(response).reduce(
      (result, [key, value]) => {
        if (key !== OTHERS && value > 0) {
          result.push(
            <div key="key">
              {Localized[ErrorCodesMap[key]].replace(placeholder, value)}
            </div>,
          );
        }
        if (key === OTHERS && value > 0) {
          if (hasLodging) {
            result.push(
              <div key="ResponseLodgingWithOtherLob">
                {Localized.ResponseLodgingWithOtherLob}
              </div>,
            );
          } else {
            result.push(
              <div key="ResponseNoLodgingWithOtherLob">
                {Localized.ResponseNoLodgingWithOtherLob}
              </div>,
            );
          }
        }
        return result;
      },
      [],
    );
    return mappedLocalizedObject;
  }

  getLocalisedNoFlexAvailable(noFlexAvailableCount) {
    const headerText = Localized[
      ErrorCodesMap.NO_FLEX_POLICY_AVAILABLE
    ].replace('{x}', noFlexAvailableCount);
    return {
      header: headerText,
    };
  }

  validationHandler(e) {
    const {
      initialState: { isEligibleServiceEnabled },
    } = this.props;
    const {
      emailAddressErrorIsVisible,
      phoneNumberErrorIsVisible,
      itineraryErrorIsVisible,
    } = this.state;

    const isAValidForm = this.isRequiredFieldsNonEmpty();
    if (
      isAValidForm &&
      !itineraryErrorIsVisible &&
      !phoneNumberErrorIsVisible &&
      !emailAddressErrorIsVisible
    ) {
      if (isEligibleServiceEnabled) {
        this.eligibilityRequestSubmitHandler(e);
      } else {
        this.bulkCancelRequestSubmitHandler(e);
      }
    } else {
      this.disableFormSubmission = false;
    }
    e.preventDefault();
  }

  eligibilityRequestSubmitHandler(e) {
    const self = this;
    const mappedEligibleResponse = {
      CANCEL_FOR_FULL_REFUND: 0,
      CANCEL_FOR_VOUCHER: 0,
      UNSUPPORTED: 0,
      OTHERS: 0,
    };
    this.disableFormSubmission = true;
    const { state: data } = this;
    const mappedRequestBody = getMappedObject(data, this.state);
    GetEligibilityDetails(mappedRequestBody)
      .then((response) => {
        this.disableFormSubmission = false;
        let hasLodgingElement = false;
        if (response.data.status_code === 'OK') {
          const responseObject = JSON.parse(response.data.body);

          const noFlexPolicyCount = responseObject.orderCancelOptions.filter(
            (orderCancelOption) => {
              return (
                orderCancelOption.cancelOption === 'NO_FLEX_POLICY_AVAILABLE'
              );
            },
          ).length;

          if (noFlexPolicyCount > 0) {
            this.setState({
              formSubmitted: true,
              isError: true,
              responseMessageObject: {
                ...self.getLocalisedNoFlexAvailable(noFlexPolicyCount),
              },
            });
            return;
          }
          responseObject.orderCancelOptions.forEach((orderCancelOption) => {
            if (orderCancelOption.product === LODGING) {
              hasLodgingElement = true;
              mappedEligibleResponse[orderCancelOption.cancelOption] += 1;
            } else {
              mappedEligibleResponse.OTHERS += 1;
            }
          });
          // show 2nd page
          this.setState({
            isEligible: true,
            formSubmitted: false,
            isError: false,
            responseMessageObject: self.getLocalizedEligibility(
              mappedEligibleResponse,
              hasLodgingElement,
            ),
          });
        } else {
          this.setState({
            formSubmitted: true,
            isError: true,
            responseMessageObject: {
              ...self.getLocalizedErrorMessageObject(response.data.body),
            },
          });
        }
      })
      .catch((error) => {
        const failureKey = 'Failed';
        this.setState({
          isEligible: false,
          formSubmitted: true,
          isError: true,
          responseMessageObject: {
            ...self.getLocalizedErrorMessageObject(failureKey),
          },
        });
      });
    e.preventDefault();
  }

  changeHandler(e) {
    this.disableFormSubmission = false;
    const { pattern, value, name } = e.target;
    const isValidValue = this.isRegexMatched(value.trim(), pattern);
    this.updateFieldState(name, value.trim(), !isValidValue);
  }

  bulkCancelRequestSubmitHandler(e) {
    const self = this;
    const { state: data } = this;
    this.disableFormSubmission = true;
    const mappedRequestBody = getMappedObject(data, this.state);
    SubmitTravelDetails(mappedRequestBody)
      .then((response) => {
        const successCode = 'RESPONSE_SUCCESS';
        const isError = response.data.body !== successCode;
        this.setState({
          formSubmitted: true,
          isError,
          responseMessageObject: {
            ...self.getLocalizedErrorMessageObject(response.data.body),
          },
        });
      })
      .catch((error) => {
        const failureKey = 'Failed';
        this.setState({
          formSubmitted: true,
          isError: true,
          responseMessageObject: {
            ...self.getLocalizedErrorMessageObject(failureKey),
          },
        });
      });
    e.preventDefault();
  }

  isRegexMatched(value, pattern) {
    const regex = new RegExp(pattern);
    const isValidValue = regex.test(value);
    return isValidValue;
  }

  updateFieldState(field, value, isInvalidValue) {
    const { state } = this;
    this.setState({
      ...state,
      [`${field}`]: value,
      [`${field}ErrorIsVisible`]: isInvalidValue,
    });
  }

  parseQueryParams() {
    const {
      queryParams: {
        itin,
        email,
        phone,
        locale,
        brand,
        campaign_id: campaignId,
        pointOfSale,
        channel_origin_id: channelOriginId,
      },
    } = this.props;
    // Provision to pass the form-fields in query params for pre-populating
    return {
      channel_origin_id: channelOriginId,
      brand,
      locale,
      pointOfSale: (pointOfSale || '').trim(),
      // eslint-disable-next-line camelcase
      campaign_id: (campaignId || '').trim(),
      itin: (itin || '').trim(),
      email: (email || '').trim(),
      phone: (phone || '').trim(),
    };
  }

  parseBrandInformation() {
    // Brand specific information can be processed here
    // To be logged & set in locale.
    const {
      initialState: { brand, metaInfo, tpid, eapid, host },
    } = this.props;
    return {
      brand,
      metaInfo,
      tpid,
      eapid,
      host,
    };
  }

  isRequiredFieldsNonEmpty() {
    let returnValue = true;
    const { itinerary, emailAddress, phoneNumber } = this.state;
    let itineraryErrorIsVisible = false;
    let emailAddressErrorIsVisible = false;
    let phoneNumberErrorIsVisible = false;

    if (itinerary === '') {
      itineraryErrorIsVisible = true;
      returnValue = false;
    }

    if (emailAddress === '') {
      emailAddressErrorIsVisible = true;
      returnValue = false;
    }

    if (phoneNumber === '') {
      phoneNumberErrorIsVisible = true;
      returnValue = false;
    }

    this.setState({
      itineraryErrorIsVisible,
      phoneNumberErrorIsVisible,
      emailAddressErrorIsVisible,
    });
    return returnValue;
  }

  showSubmissionForm() {
    this.disableFormSubmission = false;
    this.setState({
      formSubmitted: false,
      isEligible: false,
      isError: false,
    });
  }

  render() {
    const {
      emailAddress,
      emailAddressErrorIsVisible,
      phoneNumber,
      phoneNumberErrorIsVisible,
      itinerary,
      itineraryErrorIsVisible,
      formSubmitted,
      isError,
      responseMessageObject,
      isEligible,
    } = this.state;
    return (
      <div
        className="travel-alert-refund"
        style={{ background: 'white' }}
        data-test-id="travel-alert-refund"
      >
        <div className="container all-t-padding-four all-r-padding-four all-l-padding-four all-b-padding-four">
          {!formSubmitted && !isEligible && (
            <form onSubmit={this.validationHandler}>
              <div className="heder"></div>
              <div className="body">
                <div className="tar_note">
                  <div className="tar_note_heading">
                    {Localized.CancellationRequest}
                  </div>
                  <div className="tar_note_body">
                    <p>{Localized.Note}</p>
                    <p>{Localized.PartnerNote}</p>
                    <p>{Localized.SubmitNote}</p>
                    <p>
                      <span className="tar_disclaimer">
                        {Localized.Disclaimer}:&nbsp;
                      </span>
                      <span className="tar_disclaimer_underline">
                        {Localized.DisclaimerWithUnderline}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="tar_form">
                  <div className="tar_form_heading">{Localized.Heading}</div>
                  <div className="form-group">
                    <label>{Localized.Itin}:</label>
                    <input
                      className="form-control"
                      type="text"
                      id="tar_itin"
                      name="itinerary"
                      value={itinerary}
                      pattern="^[0-9]{11,15}$"
                      onChange={this.changeHandler}
                    />
                    <span
                      className={itineraryErrorIsVisible ? 'visible' : 'hidden'}
                    >
                      {Localized.ItinErrorMessage}
                    </span>
                  </div>
                  <div className="form-group">
                    <label>{Localized.EmailAddress}:</label>
                    <input
                      className="form-control"
                      type="text"
                      id="tar_emailAddress"
                      name="emailAddress"
                      value={emailAddress}
                      pattern="[a-zA-Z0-9\+._-]+@[a-zA-Z0-9\.\_\-]+\.[a-zA-Z]{2,4}"
                      onChange={this.changeHandler}
                    />
                    <span
                      className={
                        emailAddressErrorIsVisible ? 'visible' : 'hidden'
                      }
                    >
                      {Localized.EmailErrorMessage}
                    </span>
                  </div>
                  <div className="form-group">
                    <label>{Localized.PhoneNumber}:</label>
                    <input
                      className="form-control"
                      type="text"
                      id="tar_phoneNumber"
                      name="phoneNumber"
                      value={phoneNumber}
                      pattern="^[+]*[0-9]{0,4}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$"
                      onChange={this.changeHandler}
                    />
                    <span
                      className={
                        phoneNumberErrorIsVisible ? 'visible' : 'hidden'
                      }
                    >
                      {Localized.PhoneErrorMessage}
                    </span>
                  </div>
                  <div>
                    <input
                      className="btn btn-primary tar_submit"
                      type="submit"
                      value={Localized.Submit}
                      disabled={this.disableFormSubmission}
                    />
                  </div>
                </div>
              </div>
            </form>
          )}
          {isEligible && !formSubmitted && (
            <form>
              <div className="body">
                <div className="tar_note">
                  <div className="tar_note_heading">
                    {Localized.ResponseEligibleHeader}
                  </div>
                  {responseMessageObject}
                  <div>{Localized.ResponseElligibleConfirmation}</div>
                </div>
                <div className="tar_form">
                  <input
                    className="btn btn-primary tar_submit"
                    type="submit"
                    onClick={this.bulkCancelRequestSubmitHandler}
                    value={Localized.ResponseEligibleSubmit}
                    disabled={this.disableFormSubmission}
                  />
                  &nbsp;
                  <input
                    className="btn btn-primary tar_submit"
                    type="button"
                    onClick={this.showSubmissionForm}
                    value={Localized.ResponseEligibleNeverMind}
                  />
                </div>
              </div>
            </form>
          )}
          {formSubmitted && (
            <div className="body">
              <div className="tar_note">
                {!isError && (
                  <div className="tar_note_heading">{Localized.Success}</div>
                )}
                {isError && (
                  <>
                    <div className="tar_note_heading">
                      <span className="failure">
                        {responseMessageObject.header}&nbsp;
                      </span>
                    </div>
                    {}
                    <div
                      role="none"
                      className="tar_note_link"
                      onClick={this.showSubmissionForm}
                    >
                      {Localized.TryAgain}
                    </div>
                  </>
                )}
                <div className="tar_note_body">
                  <p>
                    <span className="tar_disclaimer">
                      {Localized.Disclaimer.trim()}&nbsp;
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default TravelAlertRefund;
